export const coreApps = [
    { value: 'customtables', text: 'Custom Tables' },
    { value: 'fnd', text: 'Foundation' }
] as const;

export const solutionApps = [
    { value: 'kanban', text: 'Click & Collect' },
    { value: 'campaign', text: 'Campaign' },
    { value: 'impex-helper', text: 'ImpEx Helper' }, 
    { value: 'mdbreadmi-helper', text: 'MDBREAD Helper' }, 
    { value: 'mi-test', text: 'MI Test' }, 
    { value: 'm3-printout-config', text: 'M3 Printout Config' }, 
    { value: 'vince-pricer', text: 'Vince Pricer' }, 
    { value: 'cugex-helper', text: 'Cugex Helper' },
    { value: 'isLantmannen', text: 'Lantmannen Maskin' },
    { value: 'spykar', text: 'Spykar-Channel-Plan' },
    { value: 'eshopbox', text: 'spykar-eshopbox' },
    { value: 'scanner-pick-pack', text: 'Pick-Pack-Scanner' }, 
    { value: 'pick-pack', text: 'Pick-Pack' }, 
    { value: 'contract-management', text: 'Contract-Management' }
] as const;

export const customTableResources = [
    { value: 'meta', text: 'Configuration' },
    { value: 'data', text: 'Data' }
] as const;

export const defaultAppResources = [
    { value: '*', text: '*' }
] as const;
